import { ChartGraphicOrganizerBehavior } from './ChartGraphicOrganizerBehavior';

export class KWLChartBehavior extends ChartGraphicOrganizerBehavior {
  // placeholder
}
const kwlChartBehavior = new KWLChartBehavior();
export default kwlChartBehavior;
